import { getWeekly } from '../api.js'
import RankingPage from './RankingPage.jsx'

function WeeklyPage() {
  return (
    <RankingPage
      eyebrow="WEEKLY OPEN SOURCE RADAR"
      title="每周榜"
      description="汇总最近 7 天的上榜频次、Star 增长、推荐指数与项目热度。"
      loadRanking={getWeekly}
      emptyTitle="每周榜正在积累数据"
    />
  )
}

export default WeeklyPage
